// 站点语言固定为英文
import Vue from "vue";
export const sharedState = Vue.observable({
  lang: "en",
});



// WEBPACK FOOTER //
// ./src/assets/js/languages/fanyi.js